import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

import Toast from "./components/Toast"
import {ref ,watch} from "vue";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

window.onload = function() {
  document.addEventListener('touchstart', function(event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener('gesturestart', function(event) {
    event.preventDefault()
  })
  window.addEventListener('unload', () => {
    localStorage.removeItem('goout');
  })
}

const goout = ref(false);
  const router = useRouter();
watch(
  () => router.currentRoute.value.path,
  (newValue) => {
    if (newValue !== "/homearr") {
      if(localStorage.getItem("goout")){
        goout.value = true;
      }else{
        goout.value = false;
      }
    }else{
      goout.value = false;
    }
  },
  { immediate: true }
);

const gohomearr = ()=>{
  router.push({
    name: "homearr",
  });
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_unref(Toast)),
    (goout.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "goout",
          onClick: gohomearr
        }, "返回"))
      : _createCommentVNode("", true)
  ], 64))
}
}

})